import React from 'react';
import css from './styles.module.scss';
import { Card, CardHeader, Chip, ChipProps, Grid, GridProps } from '@material-ui/core';
import AvatarGroup from '@material-ui/lab/AvatarGroup';
import Avatar from '@material-ui/core/Avatar';
import { DealContactListItem } from '~/models/contacts.dto';
import EditIcon from '@material-ui/icons/Edit';

type Props = GridProps & {
    contact: DealContactListItem;
    chipProps?: ChipProps;
    editAction?(): void;
};

export const ContactCard: React.FC<Props> = ({ contact, editAction, chipProps, ...props }) => {
    return (
        <Grid item xs={12} {...props}>
            <Card elevation={0} className={css.contactCard}>
                <CardHeader
                    className={css.contactCardHeader}
                    avatar={
                        <AvatarGroup>
                            <Avatar
                                variant="square"
                                className={css.avatar}
                                alt={contact.kontactName || ''}
                                src={contact.contactImage && `${process.env.REACT_APP_ASSET}${contact.contactImage}`}
                            />
                        </AvatarGroup>
                    }
                    title={contact.kontactName}
                    action={
                        contact.contactTypeDesc && (
                            <Chip
                                label={contact.contactTypeDesc}
                                onDelete={editAction}
                                deleteIcon={editAction && <EditIcon />}
                                {...chipProps}
                            />
                        )
                    }
                />
            </Card>
        </Grid>
    );
};
